export const settingsCookieName = "frontendSettings";

export const setSettings = (data) => {
  data = JSON.stringify(data);
  localStorage.setItem(settingsCookieName, data);
};

export const setSetting = (settingName, settingValue) => {
  const settings = getSettings();
  settings[settingName] = settingValue;

  setSettings(settings);
};

export const getSettings = () => {
  const settings = localStorage.getItem(settingsCookieName);

  if (settings) {
    return JSON.parse(settings);
  }

  return {};
};

export const getSetting = (settingName) => {
  const settings = getSettings();

  if (settings.hasOwnProperty(settingName) && settings[settingName] !== null) {
    return settings[settingName];
  }

  return null;
};